// extracted by mini-css-extract-plugin
module.exports = {"container":"_1BxBl6ht","shareStatusLabel":"_3tAz5bPT","shareStatusIcon":"byCbhZoW"};